import {Fragment} from 'react';

import {EmailingService as Service} from './EmailingService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('system.emailServerConfig');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'defaultFromDisplayName', header: t('system.alias'), minWidth: 160},
      {field: 'defaultFromAddress', header: t('system.displayAddress'), minWidth: 160},
      {field: 'useDefault', header: t('catalog.emailUsage'), width: 100, dataType: 'boolean'},
      {field: 'host', header: t('system.smtpHost'), matchMode: 'contains', minWidth: 160},
      {field: 'port', header: t('system.smtpPort'), width: 120},
      {field: 'enableSsl', header: t('system.sslAuthentication'), width: 110, dataType: 'boolean'},
      {field: 'useDefaultCredentials', header: t('system.defaultLogin'), width: 160, dataType: 'boolean'}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {field: 'defaultFromDisplayName', header: t('system.alias'), InputTextProps: {maxLength: 250}, className: 'md:col-12'},
      // {field: 'domain', header: 'Domain', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-6'},
      {field: 'defaultFromAddress', header: t('system.displayAddress'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'userName', header: t('auth.username'), required: true, type: 'email', InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'password', header: t('auth.password'), type: 'Password', required: true, className: 'md:col-6'},
      {field: 'host', header: t('system.smtpHost'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'port', header: t('system.smtpPort'), required: true, InputTextProps: {maxLength: 5, keyfilter: 'int'}, className: 'md:col-6'},
      {field: 'enableSsl', header: t('system.sslAuthentication'), type: 'Checkbox', className: 'md:col-3'},
      {field: 'useDefault', header: t('catalog.emailUsage'), type: 'Checkbox', className: 'md:col-3'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
